import gql from 'graphql-tag';

export const GENERAL_QUERY = gql`
  query historicalDeviceData(
    $deviceSerial: ID!
    $granularity: String!
    $granularityFull: String!
    $startTime: Date!
    $endTime: Date!
    $version: String!
  ) {
    deviceAppData(deviceSerial: $deviceSerial, version: $version) {
      serial
      version
      batterycharge: aggregation(
        parameter: "batterycharge"
        app: "power3_app"
        granularity: $granularity
        startTime: $startTime
        endTime: $endTime
      ) {
        aggregationResult
      }
      batterydischarge: aggregation(
        parameter: "batterydischarge"
        app: "power3_app"
        granularity: $granularity
        startTime: $startTime
        endTime: $endTime
      ) {
        aggregationResult
      }
      batterystateofcharge: aggregation(
        parameter: "batterystateofcharge"
        app: "power3_app"
        granularity: $granularity
        startTime: $startTime
        endTime: $endTime
      ) {
        aggregationResult
      }
      photovoltaicproduction: aggregation(
        parameter: "photovoltaicproduction"
        app: "power3_app"
        granularity: $granularity
        startTime: $startTime
        endTime: $endTime
      ) {
        aggregationResult
      }
      photovoltaicconsumption: aggregation(
        parameter: "photovoltaicconsumption"
        app: "power3_app"
        granularity: $granularity
        startTime: $startTime
        endTime: $endTime
      ) {
        aggregationResult
      }
      consumption: aggregation(
        parameter: "consumption"
        app: "power3_app"
        granularity: $granularity
        startTime: $startTime
        endTime: $endTime
      ) {
        aggregationResult
      }
      gridimport: aggregation(
        parameter: "gridimport"
        app: "power3_app"
        granularity: $granularity
        startTime: $startTime
        endTime: $endTime
      ) {
        aggregationResult
      }
      gridexport: aggregation(
        parameter: "gridexport"
        app: "power3_app"
        granularity: $granularity
        startTime: $startTime
        endTime: $endTime
      ) {
        aggregationResult
      }
      gridconsumption: aggregation(
        parameter: "gridconsumption"
        app: "power3_app"
        granularity: $granularity
        startTime: $startTime
        endTime: $endTime
      ) {
        aggregationResult
      }
      autarky: aggregation(
        parameter: "autarky"
        app: "power3_app"
        granularity: $granularity
        startTime: $startTime
        endTime: $endTime
      ) {
        aggregationResult
      }
      autarkyFull: aggregation(
        parameter: "autarky"
        app: "power3_app"
        granularity: $granularityFull
        startTime: $startTime
        endTime: $endTime
      ) {
        aggregationResult
      }
      photovoltaicproductionFull: aggregation(
        parameter: "photovoltaicproduction"
        app: "power3_app"
        granularity: $granularityFull
        startTime: $startTime
        endTime: $endTime
      ) {
        aggregationResult
      }
      batteryChargePhotovoltaic: aggregation(
        parameter: "batterychargephotovoltaic"
        app: "power3_app"
        granularity: $granularity
        startTime: $startTime
        endTime: $endTime
      ) {
        aggregationResult
      }
      batteryChargePhotovoltaicFull: aggregation(
        parameter: "batterychargephotovoltaic"
        app: "power3_app"
        granularity: $granularityFull
        startTime: $startTime
        endTime: $endTime
      ) {
        aggregationResult
      }
      consumptionFull: aggregation(
        parameter: "consumption"
        app: "power3_app"
        granularity: $granularityFull
        startTime: $startTime
        endTime: $endTime
      ) {
        aggregationResult
      }
      batteryChargeGridFull: aggregation(
        parameter: "batterychargegrid"
        app: "power3_app"
        granularity: $granularityFull
        startTime: $startTime
        endTime: $endTime
      ) {
        aggregationResult
      }
      gridImportFull: aggregation(
        parameter: "gridimport"
        app: "power3_app"
        granularity: $granularityFull
        startTime: $startTime
        endTime: $endTime
      ) {
        aggregationResult
      }
      gridExportFull: aggregation(
        parameter: "gridexport"
        app: "power3_app"
        granularity: $granularityFull
        startTime: $startTime
        endTime: $endTime
      ) {
        aggregationResult
      }
      batteryDischargeFull: aggregation(
        parameter: "batterydischarge"
        app: "power3_app"
        granularity: $granularityFull
        startTime: $startTime
        endTime: $endTime
      ) {
        aggregationResult
      }
      gridConsumptionFull: aggregation(
        parameter: "gridconsumption"
        app: "power3_app"
        granularity: $granularityFull
        startTime: $startTime
        endTime: $endTime
      ) {
        aggregationResult
      }
      photovoltaicConsumptionFull: aggregation(
        parameter: "photovoltaicconsumption"
        app: "power3_app"
        granularity: $granularityFull
        startTime: $startTime
        endTime: $endTime
      ) {
        aggregationResult
      }
      batteryStateOfChargeFull: aggregation(
        parameter: "batterystateofcharge"
        app: "power3_app"
        granularity: $granularityFull
        startTime: $startTime
        endTime: $endTime
      ) {
        aggregationResult
      }
    }
  }
`;

export const LATEST_APP_DATA_QUERY = gql`
  query latestAppData($deviceSerial: ID!, $version: String!) {
    deviceAppData(deviceSerial: $deviceSerial, version: $version) {
      serial
      version
      GRID_METER_APP: latest(app: "grid_meter_app")
      LG_BATTERY_APP: latest(app: "lg_battery_app")
      PV_METER_APP: latest(app: "pv_meter_app")
      POWER_INVERTER_READ_APP: latest(app: "power_inverter_read_app")
      POWER_INVERTER_WRITE_APP: latest(app: "power_inverter_write_app")
      POWER3_PARAMETER_PUBLISHER_APP: latest(app: "power3_parameter_publisher_app")
      POWER3_PARAMETER_MANAGER_APP: latest(app: "power3_parameter_manager_app")
      POWER3_DEVICE_HEARTBEAT_APP: lastDeviceUpdate
    }
  }
`;

export const LAST_MINUTE_DATA_QUERY = gql`
  query lastMinuteData($deviceSerial: ID!, $startTime: Date!, $endTime: Date!, $version: String!) {
    LATEST: deviceAppData(
      deviceSerial: $deviceSerial
      version: $version
      startTime: $startTime
      endTime: $endTime
    ) {
      GRID_METER_APP: latest(app: "grid_meter_app")
      LG_BATTERY_APP: latest(app: "lg_battery_app")
      PV_METER_APP: latest(app: "pv_meter_app")
      POWER_INVERTER_READ_APP: latest(app: "power_inverter_read_app")
      POWER_INVERTER_WRITE_APP: latest(app: "power_inverter_write_app")
      POWER3_PARAMETER_PUBLISHER_APP: latest(app: "power3_parameter_publisher_app")
      POWER3_PARAMETER_MANAGER_APP: latest(app: "power3_parameter_manager_app")
      POWER3_DEVICE_HEARTBEAT_APP: lastDeviceUpdate
    }
  }
`;

export const APPS = [
  'POWER3_PARAMETER_PUBLISHER_APP',
  'LG_BATTERY_APP',
  'PV_METER_APP',
  'GRID_METER_APP',
  'POWER_INVERTER_READ_APP',
  'POWER_INVERTER_WRITE_APP',
  'POWER3_PARAMETER_MANAGER_APP',
  'POWER3_DEVICE_HEARTBEAT_APP'
];
